module.exports = __webpack_public_path__ + "img/intro_no.ed5b7da8.svg";